<div
  fxLayout="column"
  fxFlexFill
  [ngStyle]="{ height: '70vh', overflow: 'hidden' }"
  [ngStyle.xs]="{ height: 'auto', overflow: 'auto' }"
  style="width: 100%"
>
  @if (policyStore?.policyData?.policy.quoteStatus === 'ISS' || (policyVerified &&
  policyStore?.policyData?.policy.quoteStatus !== 'ISS')){
  <apt-state-block state="success" title="Success"></apt-state-block>

  <div fxLayout="row">
    <div
      fxFlex
      fxFlexOffset.gt-sm="15"
      fxFlex.gt-sm="70"
      fxFlexOffset.gt-md="20"
      fxFlex.gt-md="60"
      style="text-align: justify"
    >
      <p>
        Your payment has been successfully processed. We will email your policy and receipt of payment shortly. The
        email will contain important information on how to make changes to your policy and how to file claims.
      </p>
    </div>
  </div>
  <div fxLayout="row">
    <div
      fxFlex
      fxFlexOffset.gt-sm="15"
      fxFlex.gt-sm="70"
      fxFlexOffset.gt-md="20"
      fxFlex.gt-md="60"
      style="
        font-family: Open Sans Semibold, Open Sans, sans-serif;
        font-weight: 600;
        color: #333f48;
        text-align: center;
        line-height: normal;
        font-size: 16px;
        margin-bottom: 16px;
      "
      fxFlex
      fxFlexOffset.gt-sm="15"
      fxFlex.gt-sm="70"
      fxFlexOffset.gt-md="20"
      fxFlex.gt-md="60"
    >
      <div fxLayout="column" fxLayoutAlign="start center" *ngIf="cyberOfferEnabled && !isCyberFlow">
        <p
          style="
            font-family: Open Sans Semibold, Open Sans, sans-serif;
            font-weight: 600;
            color: #333f48;
            text-align: center;
            line-height: normal;
            font-size: 16px;
            margin-bottom: 16px;
          "
        >
          Want Cyber insurance too? It's just few simple questions away!
        </p>

        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="24px" fxLayoutAlign="center center">
          <apt-button *ngIf="cyberOfferEnabled" class="cyber-cta" [primary]="true" (click)="navigateToCyber()">
            Begin Cyber Application
          </apt-button>

          <apt-button *ngIf="isProgressiveFlow" (click)="goBackToBQX()" secondary="default">Back to BQX</apt-button>
        </div>
      </div>
    </div>
  </div>
  }
</div>
